define('app/views/defaultAnalytics/ski',[], function () {
  return {
    requestSkiLiftTicketSelectionCatClick: function (categories, itemName) {
      var selectedCat = _.find(categories, function (cat) {
        return _.find(cat.items, function (item) {
          return item.name == itemName;
        });
      });

      if (selectedCat) {
        var item = _.find(selectedCat.items, function (item) {
          return item.name == itemName;
        });
        if (item) {
          var location =
            item.tickets && item.tickets.length > 0
              ? item.tickets[0].Location
              : "";
          gtag("event", "view_item_list", {
            item_list_id: "Ski-Items-" + location,
            item_list_name: "Ski Items on " + location,
            items: _.map(item.tickets || [], function (ticket) {
              var id  = "Ski-" + ticket.SkiItemId;
              return {
                item_id: id,
                item_name: ticket.ItemName,
                affiliation: app.localization.siteName,
                item_category: ticket.ItemCategory,
                item_category2: ticket.ItemSubCategory,
                location_id: ticket.Location,
                price: +ticket.Price,
                quantity: 1,
              };
            }),
          });
        }
      }
    },
    requestSkiLiftTicketSelectionItemClick: function (categories, itemId) {
      _.each(categories, function (cat) {
        _.each(cat.items, function (item) {
          var ticket = _.find(item.tickets, function (ticket) {
            return ticket.SkiItemId == itemId;
          });
          if (ticket) {
            var id  = "Ski-" + ticket.SkiItemId;
            gtag("event", "view_item", {
              currency: app.customization.currencyCode,
              value: +ticket.Price,
              items: [
                {
                  item_id: id,
                  item_name: ticket.ItemName,
                  affiliation: app.localization.siteName,
                  item_category: ticket.ItemCategory,
                  item_category2: ticket.ItemSubCategory,
                  location_id: ticket.Location,
                  price: +ticket.Price,
                  quantity: 1,
                },
              ],
            });
          }
        });
      });
    },
  };
});

